export const SECURITY_EMAIL = 'security@hover.to';
export const PRIVACY_EMAIL = 'privacy@hover.to';
export const SUPPORT_EMAIL = 'support@hover.to';
export const SUPPORT_PHONE = '+1.844.754.6837';
export const SDR_CALENDLY_LINK =
  'https://calendly.com/hover-sdr/hover-membership-website';
export const ADDRESS_LINE_1 = '255 Bush St, 7th Floor';
export const ADDRESS_LINE_2 = 'San Francisco, CA 94104';

export const BLOG_CATEGORIES = [
  { label: 'Case Studies', value: 'case-studies' },
  { label: 'Exterior Contractors', value: 'exterior-contractors' },
  { label: 'Homeowners', value: 'homeowners' },
  { label: 'HOVER', value: 'hover' },
  { label: 'Insurance', value: 'insurance' },
  { label: 'News', value: 'news' },
  { label: 'Product Updates', value: 'product-updates' },
];
